import { useRouter } from '@tanstack/react-router';
import { ImgHTMLAttributes } from 'react';
import { BRAND, brandAsset } from '@/lib/brand';

export const Logo = ({
  ...props
}: Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'>) => {
  const { navigate } = useRouter();
  return (
    <img
      src={brandAsset('/logo-dark.png')}
      alt={BRAND.name}
      onClick={() => navigate({ to: '/' })}
      style={{ cursor: 'pointer' }}
      {...props}
    />
  );
};
